import { SettingsRepository } from '../repositories/settings.repository'
import {
    AttachWabaTemplatesPayload,
    SettingFilters,
    SettingsGetListResponseT,
    SettingsGetNotificationItResponseT,
    SettingsGetNotificationsItListResponseT,
    SettingsGetNotificationsListResponseT,
    SettingsGetWabaTemplateCategoriesResponseT,
    SettingsGetWabaTemplatesParams,
    SettingsGetWabaTemplatesResponse,
    SettingsWabaTemplatesCreatePayload,
    SettingsWabaTemplatesGetCategoriesResponse,
    SettingsWabaTemplatesGetLanguagesResponse,
    SettingsWabaTemplatesGetStatusesResponse,
    SettingsWabaTemplatesUpdatePayload,
} from '../types/settings.types'

const settingsRepository = new SettingsRepository()

export class SettingsService {
    async getList(filters: SettingFilters): Promise<SettingsGetListResponseT> {
        const response = await settingsRepository.getList(filters)
        return response.data
    }

    async updateSettingState(setting_id: number, value: string): Promise<void> {
        const response = await settingsRepository.udpateSettingState(setting_id, value)
        return response.data
    }

    async getNotificationsList(
        filters: SettingFilters
    ): Promise<SettingsGetNotificationsListResponseT> {
        const response = await settingsRepository.getNotificationsList(filters)
        return response.data
    }

    async updateNotificationSettingState(setting_id: number, is_active: boolean): Promise<void> {
        const response = await settingsRepository.updateNotificationSettingState(
            setting_id,
            is_active
        )
        return response.data
    }

    async getNotificationIt(id: number): Promise<SettingsGetNotificationItResponseT> {
        const response = await settingsRepository.getNotificationIt(id)
        return response.data
    }

    async editTemplateNotificationIt(id: number, body: string): Promise<void> {
        const response = await settingsRepository.editTemplateNotificationIt(id, body)
        return response.data
    }

    async editCompaniesNotificationIt(settingsId: number, companyIds: number[]): Promise<void> {
        const response = await settingsRepository.editCompaniesNotificationIt(
            settingsId,
            companyIds
        )
        return response.data
    }

    async getNotificationsItList(
        page: number,
        limit: number
    ): Promise<SettingsGetNotificationsItListResponseT> {
        const response = await settingsRepository.getNotificationsItList(page, limit)
        return response.data
    }

    async enableNotificationIt(settingsId: number): Promise<void> {
        const response = await settingsRepository.enableNotificationIt(settingsId)
        return response.data
    }

    async disableNotificationIt(settingsId: number): Promise<void> {
        const response = await settingsRepository.disableNotificationIt(settingsId)
        return response.data
    }

    async getWabaTemplates(params: SettingsGetWabaTemplatesParams): Promise<SettingsGetWabaTemplatesResponse> {
        const response = await settingsRepository.getWabaTemplates(params)
        return response.data
    }

    async wabaTemplatesGetLanguages(): Promise<SettingsWabaTemplatesGetLanguagesResponse> {
        const response = await settingsRepository.wabaTemplatesGetLanguages()
        return response.data
    }

    async wabaTemplatesGetStatuses(): Promise<SettingsWabaTemplatesGetStatusesResponse> {
        const response = await settingsRepository.wabaTemplatesGetStatuses()
        return response.data
    }

    async wabaTemplatesGetCategories(): Promise<SettingsWabaTemplatesGetCategoriesResponse> {
        const response = await settingsRepository.wabaTemplatesGetCategories()
        return response.data
    }

    async createWabaTemplate(payload: SettingsWabaTemplatesCreatePayload): Promise<void> {
        const response = await settingsRepository.createWabaTemplate(payload)
        return response.data
    }

    async updateWabaTemplate(id: number, payload: SettingsWabaTemplatesUpdatePayload): Promise<void> {
        const response = await settingsRepository.updateWabaTemplate(id, payload)
        return response.data
    }

    async deleteWabaTemplate(id: number): Promise<void> {
        const response = await settingsRepository.deleteWabaTemplate(id)
        return response.data
    }

    async attachWabaTemplates(settingsId: number, payload: AttachWabaTemplatesPayload): Promise<void> {
        const response = await settingsRepository.attachWabaTemplates(settingsId, payload)
        return response.data
    }

    async syncWabaTemplate(templateId: number): Promise<void> {
        const response = await settingsRepository.syncWabaTemplate(templateId)
        return response.data
    }

    async syncWabaTemplates(): Promise<void> {
        const response = await settingsRepository.syncWabaTemplates()
        return response.data
    }

    async getWabaTemplateCategories(): Promise<SettingsGetWabaTemplateCategoriesResponseT> {
        const response = await settingsRepository.getWabaTemplateCategories()
        return response.data
    }
}
